import { cn } from '@/lib/cn'

export type ReportPeriod = 'quarter' | 'month'

/** "Quarterly / Monthly": the two ways to cut a report. A pressed button is the one in use. */
export function PeriodSwitch({ period, onChange }: { period: ReportPeriod; onChange: (p: ReportPeriod) => void }) {
  const options: { id: ReportPeriod; label: string }[] = [
    { id: 'quarter', label: 'Quarterly' },
    { id: 'month', label: 'Monthly' },
  ]
  return (
    <div role="group" aria-label="Report period" className="no-print inline-flex rounded-control border border-line-strong bg-surface p-0.5">
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          aria-pressed={period === o.id}
          onClick={() => onChange(o.id)}
          className={cn(
            'min-h-[36px] rounded-[6px] px-3 text-body font-medium transition-colors',
            period === o.id ? 'bg-brand text-white' : 'text-neutral hover:bg-neutral-tint',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
